/* erzeugt aus preview/ (shop-port.js) */
/* OTHERSPORTS · Collection – vier Bausteine und Wisch-Reihe
   Die Beispielübungen im Baustein „Geführtes Training" stammen wörtlich aus dem veröffentlichten
   Core-Plan (sections/os-core-training-page.liquid, Level 1) samt der echten Start-Bilder. */
(function () {
  /* Vier Bausteine: ein Reiter links, der Inhalt rechts. Reine Umschaltung, keine Animation. */
  var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-baustein]'));
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      var id = t.getAttribute('data-baustein');
      tabs.forEach(function (o) { o.setAttribute('aria-selected', String(o === t)); });
      document.querySelectorAll('[data-baustein-inhalt]').forEach(function (inh) {
        var an = inh.getAttribute('data-baustein-inhalt') === id;
        inh.hidden = !an; inh.classList.toggle('is-on', an);
      });
    });
  });

  starteSlider();

  /* ---------- Wisch-Reihe: Punkte zeigen, welche Karte gerade im Blick ist ---------- */
  function starteSlider() {
    document.querySelectorAll('[data-slider]').forEach(function (reihe) {
      var name = reihe.getAttribute('data-slider');
      var punkte = document.querySelector('[data-dots="' + name + '"]');
      if (!punkte) return;
      var kacheln = Array.prototype.slice.call(reihe.children);
      var i = Array.prototype.slice.call(punkte.children);
      function markiere() {
        if (reihe.scrollWidth <= reihe.clientWidth + 8) { punkte.hidden = true; return; }
        punkte.hidden = false;
        var mitte = reihe.scrollLeft + reihe.clientWidth / 2, nah = 0, d = 1e9;
        kacheln.forEach(function (k, n) { var a = Math.abs(k.offsetLeft + k.offsetWidth / 2 - mitte); if (a < d) { d = a; nah = n; } });
        i.forEach(function (p, n) { p.classList.toggle('is-on', n === nah); });
      }
      reihe.addEventListener('scroll', markiere, { passive: true });
      window.addEventListener('resize', markiere);
      markiere();
    });
  }
})();

/* Vergleich der drei Sportboards als Pop-up (Ronny 17.10.): öffnet über die Knöpfe oder über #vergleich in der Adresse
   (so kommt die Startseite „Sportboards im Vergleich ansehen“ direkt in die Übersicht). */
(function () {
  var dlg = document.getElementById('osc-vergleich');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  function oeffne() {
    if (dlg.open) return;
    dlg.showModal();
    dlg.scrollTop = 0;
    document.body.classList.add('is-locked');
    if (window.osTrack) window.osTrack('collection_vergleich');
  }
  function schliesse() { if (dlg.open) dlg.close(); }
  document.querySelectorAll('[data-osc-vergleich-open]').forEach(function (k) { k.addEventListener('click', function (e) { e.preventDefault(); oeffne(); }); });
  document.querySelectorAll('[data-osc-vergleich-close]').forEach(function (k) { k.addEventListener('click', schliesse); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) schliesse(); });   // Klick auf den abgedunkelten Rand
  dlg.addEventListener('close', function () { document.body.classList.remove('is-locked'); });
  if (window.location.hash === '#vergleich') window.setTimeout(oeffne, 150);
  window.addEventListener('hashchange', function () { if (window.location.hash === '#vergleich') oeffne(); });
})();
